export default __webpack_public_path__ + "dist/media/Rejected.322576d3.svg";